import { createFileRoute } from '@tanstack/react-router'

import { exportReportDocument } from '@/components/report-viewer/export'
import { GrowerReport } from '@/components/reports/growers/grower-report'
import { validateGrowerReportSearch } from '@/components/reports/growers/grower-report-search'
import { ReportPage } from '@/components/reports/report-page'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/reports/growers')({
    validateSearch: validateGrowerReportSearch,
    component: GrowerReportPage,
})

function GrowerReportPage() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const { hasPermission } = useAuth()
    return (
        <ReportPage title={m.grower_report_page_title()}>
            <GrowerReport
                search={search}
                onSearchChange={(next) =>
                    void navigate({
                        search: (prev) => ({ ...prev, ...next }),
                        replace: true,
                    })
                }
                exportDocument={
                    hasPermission('reports.export')
                        ? exportReportDocument
                        : undefined
                }
            />
        </ReportPage>
    )
}
